module.exports = __webpack_public_path__ + "img/2_3.82cf1f0f.jpg";